import { PageLink } from '../../../_start/layout/core';

export const customerManagementSubmenu: Array<PageLink> = [
  {
    title: 'Customers',
    path: '/customer-management/customers',
    isActive: true,
  },
];
